"use client";
import { useState, useEffect, useRef } from "react";

declare global {
  interface Window {
    acceptCookies?: () => void;
  }
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted") === "true";
    if (!cookiesAccepted) setShow(true);
  }, []);

  // Skriv höjden till --cookie-offset och uppdatera vid resize/innehållsändring
  useEffect(() => {
    if (!show || !ref.current) return;

    const el = ref.current;
    const setOffset = () => {
      const h = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty("--cookie-offset", `${h}px`);
    };

    const ro = new ResizeObserver(setOffset);
    ro.observe(el);

    // hantera även orientation change / viewport-resize
    window.addEventListener("resize", setOffset);
    setOffset();

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", setOffset);
      document.documentElement.style.removeProperty("--cookie-offset");
    };
  }, [show]);

  const accept = () => {
    window.acceptCookies?.(); // Google Consent Mode
    localStorage.setItem("cookiesAccepted", "true");
    setShow(false);
    document.documentElement.style.removeProperty("--cookie-offset");
  };

  if (!show) return null;

  return (
    <div
      ref={ref}
      className="cookie-banner fixed left-0 right-0 bottom-0 z-[50] flex items-center gap-4 text-white bg-gray-900 p-5"
    >
      <p className="text-sm md:text-base">
        Vi använder cookies för annonsering och statistik
      </p>
      <button
        onClick={accept}
        className="px-4 py-2 ml-auto bg-blue-600 rounded"
      >
        Acceptera
      </button>
    </div>
  );
}
